/**
 * Flow errors that require special display/handling in the application
 * Each flow error has:
 * - id: The error identifier (e.g., 'FE16')
 * - type: The category/type of error for grouping and status determination
 * - description: Human-readable description of the error
 */
export const FLOW_ERRORS = {
  FE16: {
    id: 'FE16',
    type: 'looped',
    description: 'Looped status error'
  },
  FE22: {
    id: 'FE22',
    type: 'looped',
    description: 'Water Looped status error'
  },
  //TODO: this needs to be replaced for the proper Osiris logic...
  UE10050: {
    id: 'UE10050',
    type: 'new_sensor',
    description: 'New sensor detected'
  },
  //TODO: those errors need to be replaced for the proper osiris logic...
    UE10040: {
    id: 'UE10040',
    type: 'no_sensor',
    description: 'No sensor detected'
  },
  //TODO: those errors need to be replaced for the proper osiris logic...
    BE702: {
    id: 'BE702',
    type: 'no_water',
    description: 'No water detected'
  },
    FE5: {
    id: 'FE5',
    type: 'no_sensor',
    description: 'No sensor detected'
  },
};

/**
 * Checks if an issue is a flow error that requires special handling
 * @param {string} issueId - The issue ID to check
 * @returns {Object|null} - Flow error configuration or null
 */
export const getFlowError = (issueId) => {
  return FLOW_ERRORS[issueId] || null;
};

/**
 * Checks if an issue is a flow error
 * @param {string} issueId - The issue ID to check
 * @returns {boolean} - True if it's a flow error
 */
export const isFlowError = (issueId) => {
  return Object.hasOwnProperty.call(FLOW_ERRORS, issueId);
};

/**
 * Gets all flow errors of a specific type
 * @param {string} type - The flow error type (e.g., 'looped', 'blocked')
 * @returns {Array} - Array of flow error IDs matching the type
 */
export const getFlowErrorsByType = (type) => {
  return Object.values(FLOW_ERRORS)
    .filter(error => error.type === type)
    .map(error => error.id);
};

/**
 * Gets all available flow error types
 * @returns {Array} - Array of unique flow error types
 */
export const getFlowErrorTypes = () => {
  return [...new Set(Object.values(FLOW_ERRORS).map(error => error.type))];
};